import { useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { money } from "./cassaApi";
import { styleOf, Symbol, useColors } from "./colors";
import { StateBadge } from "../warehouse/whApi";

export const copyCode = (code) => navigator.clipboard?.writeText(code).then(() => toast.success("Codice copiato"), () => {});

export function CodeBadge({ code, big, testid }) {
  return (
    <button type="button" data-testid={testid} onClick={(e) => { e.stopPropagation(); copyCode(code); }} title="Clic per copiare il codice"
      className={`press font-mono font-extrabold tracking-tight rounded-md bg-slate-900 text-white px-2 py-0.5 ${big ? "text-[1.3em]" : "text-[13px]"}`}>{code}</button>
  );
}

export function Printers({ p, hits, testid }) {
  const [open, setOpen] = useState(false);
  const list = hits?.length ? [...hits, ...p.printers.filter((x) => !hits.includes(x))] : p.printers;
  if (!list.length) return null;
  const shown = open ? list : list.slice(0, 3);
  return (
    <div className="flex flex-wrap gap-1 mt-1" data-testid={testid}>
      {shown.map((h) => <span key={h} className={`text-[13px] px-1.5 rounded ${hits?.includes(h) ? "bg-green-200 text-green-950 font-semibold" : "bg-white/60"}`}>{h}</span>)}
      {list.length > 3 && <button type="button" onClick={(e) => { e.stopPropagation(); setOpen(!open); }} className="text-[13px] font-semibold underline">{open ? "meno" : `+${list.length - 3} stampanti`}</button>}
    </div>
  );
}

export function ArticleCard({ p, hits, onAdd, view, pts }) {
  const { cats } = useColors();
  const { fill, badge, style } = styleOf(p, cats);
  const others = p.offers?.filter((o) => o.id !== p.id) || [];
  return (
    <div className={`rounded-lg border-solid flex items-start gap-3 ${view?.dense ? "p-2" : "p-3"}`} style={style} data-testid={`cassa-result-${p.id}`}>
      <div className="min-w-0 flex-1 space-y-1">
        <div className="flex flex-wrap items-center gap-2">
          <CodeBadge code={p.code} big testid={`cassa-code-${p.id}`} />
          <Symbol cat={fill} /><Symbol cat={badge} />
          {p.discontinued && <span className="text-[11px] font-bold px-1.5 py-0.5 rounded bg-slate-400 text-white">FUORI PRODUZIONE</span>}
        </div>
        <div className="text-[14px] leading-snug line-clamp-2">{p.desc_clean || p.description}</div>
        {!view?.dense && <Printers p={p} hits={hits} testid={`cassa-printers-${p.id}`} />}
        {others.length > 0 && <div className="text-[13px] opacity-80">{p.supplier}{others.map((o) => ` · ${o.supplier} ${money(o.price)}`).join("")}</div>}
      </div>
      <div className="text-right shrink-0">
        <div className="font-extrabold text-[1.35em] leading-tight">{money(p.price)}</div>
        <div className="text-[13px] opacity-70">IVA {p.vat}%</div>
        {p.stock_state && p.stock_state !== "catalogo" && <div className="mt-0.5" data-testid={`cassa-result-stock-${p.id}`}><StateBadge s={p.stock_state} /> <span className="text-[13px] font-mono font-bold">{p.stock}</span></div>}
        {pts > 0 && <div className="text-[13px] font-semibold text-amber-800" data-testid={`cassa-result-pts-${p.id}`}>+{pts} pt</div>}
      </div>
      {onAdd && <button data-testid={`cassa-add-${p.id}`} onClick={() => onAdd(p)} className="press h-12 w-12 shrink-0 grid place-items-center rounded-lg bg-brand-yellow text-brand-navy shadow"><Plus className="w-7 h-7" /></button>}
    </div>
  );
}
